module.exports = __webpack_public_path__ + "static/img/profile.91ca949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/student-smart/profile.png
// module id = X/Eb
// module chunks = 1